import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../../_services/product.service';
import { ProductComponent } from '../product.component';
import { DomSanitizer} from '@angular/platform-browser';

declare var $: any;

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit {

  link: string;
  id: number;
  country: string;
  language: string;

  productName: string;

  images: any;
  video: any;

  slideGallery = {
    'slidesToShow': 1,
    'slidesToScroll': 1,
    'arrows': false,
    'fade': true,
    'asNavFor': '.thumbnails'
  };

  slideThumbnails = {
    'slidesToShow': 5,
    'slidesToScroll': 1,
    'asNavFor': '.gallery',
    'dots': false,
    'centerMode': true,
    'centerPadding': '10px',
    'focusOnSelect': true,
    'vertical': false,
    'arrows': true,
    'swipe': true,
    'swipeToSlide': true,
    'verticalSwiping': true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    private sanitizer:DomSanitizer
  ) { }

  ngOnInit(): void {
    this.productService.product.subscribe(data => {

      if(data) {

        this.images = data.images;

        if(data.text !== undefined && data.text[0] !==undefined && data.text[0].video !== undefined && data.text[0].videoThumbnail !== undefined){
            this.video = {
                link: this.sanitizer.bypassSecurityTrustResourceUrl('http://www.youtube.com/embed/' + data.text[0].video),
                thumbnail: data.text[0].videoThumbnail
            };
        }
      }
    });
  }

}
